import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faImage,
  faFileAlt,
  faHeadphones,
  faStickyNote
} from '@fortawesome/free-solid-svg-icons';

const ComposerAttachmentMenu = ({
  isOpen,
  onClose,
  onSelectAction,
  menuRef,
  isDark
}) => {
  if (!isOpen) return null;

  const menuItems = [
    {
      id: 'media',
      label: 'Fotos y videos',
      icon: faImage,
      iconColor: '#0284c7',
      iconBg: isDark ? 'rgba(2, 132, 199, 0.2)' : 'rgba(2, 132, 199, 0.12)',
      description: 'Fotos (compresión auto) · Video máx 16 MB'
    },
    {
      id: 'document',
      label: 'Documento',
      icon: faFileAlt,
      iconColor: '#8b5cf6',
      iconBg: isDark ? 'rgba(139, 92, 246, 0.2)' : 'rgba(139, 92, 246, 0.12)',
      description: 'PDF, Word, Excel (máx 100 MB)'
    },
    {
      id: 'audio',
      label: 'Audio o música',
      icon: faHeadphones,
      iconColor: '#ea580c',
      iconBg: isDark ? 'rgba(234, 88, 12, 0.2)' : 'rgba(234, 88, 12, 0.12)',
      description: 'Audios y notas de voz (máx 16 MB)'
    },
    {
      id: 'note',
      label: 'Nota interna',
      icon: faStickyNote,
      iconColor: '#d97706',
      iconBg: isDark ? 'rgba(217, 119, 6, 0.2)' : 'rgba(217, 119, 6, 0.12)',
      description: 'Nota privada para el equipo'
    }
  ];

  return (
    <div
      ref={menuRef}
      className="position-absolute shadow-lg"
      style={{
        bottom: '100%',
        left: '12px',
        marginBottom: '10px',
        zIndex: 1065,
        width: '260px',
        borderRadius: '16px',
        backgroundColor: isDark ? '#182635' : '#ffffff',
        border: isDark ? '1px solid #233142' : '1px solid #e2e8f0',
        padding: '6px',
        animation: 'modalDialogScaleIn 0.18s cubic-bezier(0.16, 1, 0.3, 1) forwards'
      }}
    >
      <div className="d-flex flex-column gap-1">
        {menuItems.map(item => (
          <button
            key={item.id}
            type="button"
            className="btn btn-sm d-flex align-items-center gap-2.5 p-2 text-start border-0 rounded-3 shadow-none w-100"
            style={{
              backgroundColor: 'transparent',
              transition: 'background-color 0.12s ease'
            }}
            onMouseEnter={e => {
              e.currentTarget.style.backgroundColor = isDark ? '#1e293b' : '#f1f5f9';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.backgroundColor = 'transparent';
            }}
            onClick={() => {
              onSelectAction(item.id);
              onClose();
            }}
          >
            <div
              className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
              style={{
                width: '34px',
                height: '34px',
                backgroundColor: item.iconBg,
                color: item.iconColor
              }}
            >
              <FontAwesomeIcon icon={item.icon} style={{ fontSize: '0.92rem' }} />
            </div>
            <div className="d-flex flex-column overflow-hidden">
              <span
                style={{
                  fontSize: '0.84rem',
                  fontWeight: 600,
                  color: isDark ? '#f1f5f9' : '#1e293b',
                  lineHeight: 1.2
                }}
              >
                {item.label}
              </span>
              <span
                className="text-truncate"
                style={{
                  fontSize: '0.70rem',
                  color: isDark ? '#94a3b8' : '#64748b',
                  lineHeight: 1.3
                }}
              >
                {item.description}
              </span>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

ComposerAttachmentMenu.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSelectAction: PropTypes.func.isRequired,
  menuRef: PropTypes.object.isRequired,
  isDark: PropTypes.bool
};

export default ComposerAttachmentMenu;
